import axios from "axios";

export default function logout() {
  axios.delete(`${window.location.origin}/backend/api/lk/session`).then(() => {
    localStorage.removeItem("auth_token");
    sessionStorage.removeItem("auth_token");
    sessionStorage.removeItem("rtk_user");
    sessionStorage.removeItem("recommendation");
    document.cookie = `auth_token=${encodeURIComponent("")}`;
    location.href = "/";
  });
}



// WEBPACK FOOTER //
// ./app/frontend/components/logout.js